module.exports = __webpack_public_path__ + "fonts/Marianne-Medium.05b552b.woff2";